import Config from '$root/Config';

export default function filterModelsPlugin (filterModule) {
    return store => {
        filterModule.forEach(fm => {
            store.commit(`${fm}/initFilters`, Config.dataModuleFilters[fm]);
        });
    }
}